var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLockKeyOpen = function SvgIconLockKeyOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 16.196a2.876 2.876 0 1 0-2 0v.679a1 1 0 1 0 2 0zM11.125 13.5a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.868 2.483a2.375 2.375 0 0 1 2.494 2.122 1 1 0 0 0 1.989-.21 4.375 4.375 0 0 0-8.726.483V7.25H4.5A1.75 1.75 0 0 0 2.75 9v10.5c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75V9a1.75 1.75 0 0 0-1.75-1.75H9.625V4.869a2.375 2.375 0 0 1 2.243-2.386M8.614 9.25H19.25v10H4.75v-10z"
  }))));
};
export default SvgIconLockKeyOpen;